
export const EmptySignatureState = () => {
  return (
    <div className="col-span-full bg-white rounded-[24px] w-full min-h-[300px]">
      <div className="flex flex-col items-center justify-center h-full">
        <p className="text-gray-500 text-xl">No signatures saved yet</p>
      </div>
    </div>
  );
};
